import { get } from "lodash";
import parseCapiMessage from "@tvg/utils/capiUtils";
import { Whitelist } from "@tvg/sh-lib-beta-program/types";
import {
  AlertMessages,
  ModalContent,
  State
} from "@tvg/sh-lib-beta-program/types/redux";
import { User } from "@tvg/ts-types/Login";
import { isTvg5 } from "@tvg/utils/generalUtils";
import {
  betaProgramModal,
  myStable,
  programPage,
  alertMessages
} from "../defaultValues";

export const getBetaProgramModal = (state: State) =>
  get(state, "betaProgram.splashModal", betaProgramModal);

export const getBetaFeaturesPreviewModal = (state: State) =>
  get(state, "betaProgram.featurePreviewModal", betaProgramModal);

export const getBetaProgramContent = (state: State): ModalContent => {
  const path = isTvg5()
    ? "capi.messages.betaProgramPageContent"
    : "betaProgram.content.programPage";

  return parseCapiMessage(state, path, programPage);
};

export const getBetaMyStableContent = (state: State): ModalContent => {
  const path = isTvg5()
    ? "capi.messages.betaMyStableContent"
    : "betaProgram.content.myStable";

  return parseCapiMessage(state, path, myStable);
};

export const getBetaWhitelist = (state: State): Whitelist[] => {
  const path = isTvg5()
    ? "capi.messages.betaProgramWhiteList"
    : "betaProgram.whitelist";

  return parseCapiMessage(state, path, []);
};

export const getAlertMessages = (state: State): AlertMessages => {
  const path = isTvg5()
    ? "capi.messages.betaProgramAlertMessages"
    : "betaProgram.content.alertMessages";

  return parseCapiMessage(state, path, alertMessages);
};

export const getUser = (state: State): User => get(state, "userData.user");
